import Web3 from 'web3'
import tokenContractABI from './tokenContractABI'
import agentContractABI from './agentContractABI'
import getWallet from '../../composables/getWallet'
import { createDocument } from '../useDocument'
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'

const INFURA_API_KEY = '0dae6079f0394a029e9ce6c0cb25e6ba'
const INFURA_URL = 'https://sepolia.infura.io/v3/'
const rpcURL = INFURA_URL + INFURA_API_KEY
const TEXAVIE_COIN_ADDRESS = '0xD8D6CE68b9112A34781d331afD78Db1CBfAC4a65'
const AGENT_OWNER_PRIVATE_KEY = '914b0db6f0df97d57707ca2d1f5016e8c0dd3c4e5c879892607c1c6ba1e2d4b9'
const agentContractAddress = '0xD311200379A55b9741F47e15dcC61fd8d43C41De'

const { handleCreate } = createDocument('web3Wallets')
const { getWalletByUid, walletInfo } = getWallet()

const web3Service = () => {
  const web3 = new Web3(rpcURL)
  const erc20TexavieContract = new web3.eth.Contract(tokenContractABI, TEXAVIE_COIN_ADDRESS)
  const agentContract = new web3.eth.Contract(agentContractABI, agentContractAddress)
  const agentAdminAccount = web3.eth.accounts.privateKeyToAccount(AGENT_OWNER_PRIVATE_KEY)

  const getBalance = async (walletAddress) => {
    const balanceBigNumber = await erc20TexavieContract.methods.balanceOf(walletAddress).call()
    const balance = balanceBigNumber.toString()
    return web3.utils.fromWei(balance, 'ether')
  }

  const createWallet = async (password, uid, email) => {
    const account = web3.eth.accounts.create()
    const keyStore = web3.eth.accounts.encrypt(account.privateKey, password)
    const keyData = JSON.stringify(keyStore.crypto)
    const blob = new Blob([keyData], { type: 'application/json' })
    const blobField = firebase.firestore.Blob.fromUint8Array(new Uint8Array(await blob.arrayBuffer()))

    await handleCreate(uid, {
      address: account.address,
      data: blobField,
      email
    })
  }

  const importWallet = async (password, key, uid, email) => {
    const account = web3.eth.accounts.privateKeyToAccount(key)
    const keyStore = web3.eth.accounts.encrypt(account.privateKey, password)
    const keyData = JSON.stringify(keyStore.crypto)
    const blob = new Blob([keyData], { type: 'application/json' })
    const blobField = firebase.firestore.Blob.fromUint8Array(new Uint8Array(await blob.arrayBuffer()))

    await handleCreate(uid, {
      address: account.address,
      data: blobField,
      email
    })
  }

  const exportWallet = async (uid, password) => {
    await getWalletByUid(uid)
    const arrayBuffer = walletInfo.value.data.toUint8Array()
    // Use TextDecoder to decode the Uint8Array to a string
    const decoder = new TextDecoder()
    const keyDataString = decoder.decode(arrayBuffer)

    // Parse the string to get the original key data as an object
    const keyData = JSON.parse(keyDataString)
    const keystore = {
      version: 3,
      id: '',
      address: walletInfo.value.address,
      crypto: keyData
    }

    const decryptedAccount = web3.eth.accounts.decrypt(keystore, password)
    return decryptedAccount.privateKey
  }

  const removeCoinsFromUser = async (userAddress, email, value) => {
    const numberOfCoinsInWei = web3.utils.toWei(value, 'ether')
    const transaction = agentContract.methods.deductCoinsFromUser(userAddress, email, numberOfCoinsInWei)

    const tx = {
      nonce: await web3.eth.getTransactionCount(agentAdminAccount.address),
      to: agentContractAddress,
      gas: await transaction.estimateGas({ from: agentAdminAccount.address }),
      data: transaction.encodeABI()
    }

    const signedTx = await web3.eth.accounts.signTransaction(tx, AGENT_OWNER_PRIVATE_KEY)
    const receipt = await web3.eth.sendSignedTransaction(signedTx.rawTransaction)
    return receipt
  }

  return { getBalance, createWallet, importWallet, exportWallet, removeCoinsFromUser }
}

export default web3Service
